import { Col, Row } from "antd";
import { TFunction, withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";

import i18n from "i18next";
import {
  Extra,
  FooterSection,
  Label,
  Language,
  LanguageSwitch,
  LanguageSwitchContainer,
  Large,
  LogoContainer,
  Para,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={24}>
              <Language>{t("Contact")}</Language>
              <Large to="/">{t("Tell us everything")}</Large>
              <Para>
                {t(
                  "Do you have any questions? Email us on contact@brazilglobalmining.com.br."
                )}
              </Para>
            </Col>

            <Col lg={8} md={8} sm={12} xs={24}>
              <Language>{t("Address")}</Language>
              <Para>Brasil</Para>
              <Para>Conjunto 2, SHIS QI 1 Casa 05</Para>
              <Para>Lago Sul, Brasília - DF, 71610-055</Para>
            </Col>

            <Col lg={6} md={6} sm={24} xs={24}>
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("ch")}>
                  <img
                    src="/img/icons/china.png"
                    alt="Chinese"
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </LanguageSwitch>

                <LanguageSwitch onClick={() => handleChange("pt")}>
                  <img
                    src="/img/icons/brazil.png"
                    alt="Português"
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </LanguageSwitch>

                <LanguageSwitch onClick={() => handleChange("en")}>
                  <img
                    src="/img/icons/us.png"
                    alt="English"
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>

      <Extra>
        <Container border={true}>
          <Row
            justify="center"
            align="middle"
            style={{
              paddingTop: "2rem",
              textAlign: "center",
              flexDirection: "column",
            }}
          >
            <LogoContainer
              style={{ justifyContent: "center", marginBottom: "1rem" }}
            >
              <SvgIcon
                src="logo192.png"
                aria-label="homepage"
                width="90px"
                height="64px"
              />
            </LogoContainer>
            <Para style={{ fontSize: "14px", color: "#757575" }}>
              © {new Date().getFullYear()} BGM - Brazil Global Mining.{" "}
              {t("All rights reserved")}.
            </Para>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
